import { useEffect, useState } from "react";

/** Presentation-only ticking countdown to an ISO timestamp — doesn't drive any billing logic. */
export function useCountdown(target: string | null): { label: string; expired: boolean } {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!target) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!target) return { label: "—", expired: false };

  const remainingMs = new Date(target).getTime() - now;
  const expired = remainingMs <= 0;
  const totalSeconds = Math.max(0, Math.floor(remainingMs / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return { label: `${minutes}:${seconds.toString().padStart(2, "0")}`, expired };
}
